import { InputSelect } from "components/Atomos/Form/Elements/InputSelect";
import { useEffect } from "react";
import { Control, FieldError } from "react-hook-form";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { getTipoManifestacaoRequest } from "store/modules/ouvidoria/manifestacoes/actions/getTipoManifestacao";

type Props = {
  name: string;
  label: string;
  control: Control<any, object>;
  error?: FieldError;
};

export function TipoManifestacaoSelect({ name, label, control, error }: Props) {
  const { successPayload, isRequesting } = useTypedSelector(
    (x) => x.ouvidoria.manifestacoes.getTipoManifestacao
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (successPayload.length <= 0) {
      dispatch(getTipoManifestacaoRequest());
    }
  }, [dispatch]);

  return (
    <InputSelect
      name={name}
      label={label}
      control={control}
      error={error}
      isLoading={isRequesting}
      option={successPayload.map((item) => ({
        value: item.id.toString(),
        label: item.tipoManifestacao
      }))}
    />
  );
}
